import styled from 'styled-components';

export const Thead = styled.thead`
  box-shadow: var(--box-shadow);
  background: var(--background-color);
  position: sticky;
  top: 0;
`;

export const Th = styled.th`
  padding: 16px;
  color: var(--color);
  font-family: 'GothamBold';
  vertical-align: middle;
`;

export const SearchInputCol = styled.input`
  padding: 10px 5px;
  color: var(--color);
  outline: 1px solid var(--color);
  width: 100%;
  font-size: 1.4rem;
  background: none;
  font-family: 'GothamLight', Arial, Helvetica, sans-serif;
`;
